import React from 'react';
import { ClassAssembly10C2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly10C2026 />;
  };
  
  export default ClassAssemblyPage;